export default {
	auth: {
		errorPleaseRetry: 'Er is iets foutgegaan tijdens het inloggen, probeer het opnieuw',
		noAdminRoleError: 'Gebruiker heeft geen admin rechten'
	},
	payment: {
		type: 'Soort betaling',
		amount: 'Bedrag',
		date: 'Datum',
		transfer: 'Overschrijving',
		pin: 'Pinbetaling',
		cash: 'Cash',
		listEmptyText: 'Geen betalingen om weer te geven',
		addPayment: 'Betaling toevoegen',
	},
	planning: {
		title: 'Planning',
		week: 'Week',
		day: 'Dag',
		month: 'Maand',
		createType: 'Beheer afspraaktypes'
	},
	common: {
		login: 'Login',
		actions: 'Acties',
		buyer: 'Cliënt',
		buyers: 'Cliënten',
		seller: 'Inbrenger',
		sellers: 'Inbrengers',
		item: 'Kavel',
		items: 'Kavels',
		auction: 'Veiling',
		pendingBids: 'Biedingen',
		bids: 'Aankopen',
		dashboard: 'Dashboard',
		date: 'Datum',
		price: 'Prijs',
		createdAt: 'Aangemaakt op',
		emailLogs: 'E-maillog',
		cancel: 'Annuleren',
		create: 'Aanmaken',
		downloadReport: 'Download rapportage',
		downloadInvoice: 'Download factuur',
		invoice: 'Factuur',
		report: 'Rapportage',
		invoiceType: 'Type',
		name: 'Naam',
		category: 'Categorie',
		save: 'Opslaan',
		email: 'Email',
		paidAt: 'Betaald op',
		auctionDashboard: 'Veiling dashboard',
		select: 'Selecteer',
		selected: 'Geselecteerd',
		deselect: 'Verwijderen',
		clientBidNumber: 'Cliënt biednummer',
		clientBidNumberShort: 'Biednr',
		client: 'Client',
		resetSort: 'Reset sortering',
		financial: 'Financieel',
		emailSend: 'Email succesvol verstuurd.',
		emailInvoice: 'Verstuur via email',
		requiredFields: '* Velden met een * zijn verplicht',
		editPerson: '{name} bewerken',
		chooseFile: 'Kies een bestand...',
		upload: 'Uploaden',
		errors: 'Foutmeldingen',
		bidPrice: 'Bedrag',
		warning: 'Pas op!',
		payments: 'Betalingen',
	},
	bid: {
		createSuccess: 'Aankoop is succesvol aangemaakt',
		updateSuccess: 'Aankoop is succesvol opgeslagen',
		deleteSuccess: 'Aankoop is succesvol verwijderd',
		deleteError: 'Er is iets fout gegaan met het verwijderen',
		updateError: 'Er is iets fout gegaan met het opslaan',
		price: 'Hamerbedrag',
		itemBidTitle: 'Aankoop van kavel {title}',
		itemBid: 'Aankoop van kavel',
		bidNumber: 'Biednummer',
		deleteBidOn: 'de aankoop van "{title}"',
		edit: 'Aankoop aanpassen',
		listEmptyText: 'Er zijn geen aankopen om weer te geven',
		listEmptyFilteredText: 'Er zijn geen aankopen die aan jouw zoekopdracht voldoen',
		thisBid: 'deze aankoop',
		noBuyerForBidnumer: 'Er is geen cliënt gekoppeld aan dit biednummer.',
		delete: 'Aankoop verwijderen',
		deleteBidModal: 'deze aankoop'
	},
	pendingBid: {
		createSuccess: 'Bieding is succesvol aangemaakt',
		updateSuccess: 'Bieding is succesvol opgeslagen',
		deleteSuccess: 'Bieding is succesvol verwijderd',
		addTitle: 'Bieding toevoegen',
		editTitle: 'Bieding aanpassen',
		price: 'Bedrag',
		deleteMessage: 'de bieding op {pendingBid}',
		noData: 'Geen biedingen voor dit kavel.',
		number: 'Biednummer',
		numberSmall: 'Biednr.',
		auctionOrderNumberSmall: 'Lotnr.',
		add: 'Bieding toevoegen',
		listEmptyText: 'Er zijn geen biedingen om weer te geven',
		listEmptyFilteredText: 'Er zijn geen biedingen die aan jouw zoekopdracht voldoen',
		pendingBidOnItem: 'Bieding op kavel',
		searchPlaceholder: 'Zoek op lotnummer of biednummer',
		bidNumbers: "Biednummer toevoegen",
		selectBidNumber: "Selecteer een bestaand biednummer",
		useFixedBidNumber: "Gebruik vast biednummer",
		useNewBidNumber: "Gebruik nieuw biednummer",
		useOtherBidNumber: "Gebruik niet vast biednummer",
		selectBidNumberType: "Selecteer biednummertype"
	},
	auction: {
		createSuccess: 'Veiling is succesvol aangemaakt',
		updateSuccess: 'Veiling is succesvol opgeslagen',
		deleteSuccess: 'Veiling is succesvol verwijderd',
		activity: 'Veiling activiteit',
		activityOf: 'Veiling activiteit van {name}',
		list: 'Veilingen beheer',
		add: 'Veiling toevoegen',
		edit: 'Veiling aanpassen',
		live: 'Live',
		stopLive: 'Live veiling stoppen',
		noAuctionOrderNumberForAuction: 'Er zijn geen lotnummers gevonden voor deze categorie.',
		billRemarkText: 'Factuur opmerking',
		billFooterText: 'Factuur footer',
		overviewRemarkText: 'Rapportage opmerking',
		overviewFooterText: 'Rapportage footer',
		listEmptyText: 'Er zijn geen veilingen om weer te geven',
		listEmptyFilteredText: 'Er zijn geen veilingen die aan jouw zoekopdracht voldoen',
		photos: 'Foto\'s',
		auctionPhotos: 'Veiling foto uploader',
		photoFileExample: 'Voorbeeld bestandsnaam',
		photoFilenameExample: '{inbrengcode}-{kavelnummer}-nX.{jpg|jpeg|png}',
		lists: 'Lijsten',
		sellerInvoiceEmail: 'Standaard email tekst inbrenger rapportage',
		buyerInvoiceEmail: 'Standaard email tekst cliënt factuur',
	},
	lists: {
		catalog: 'Download catalogus',
		masterCatalog: 'Master catalogus',
		userCatalog: 'Gebruikers catalogus',
		registerCatalog: 'Inboeklijst catalogus',
		allCatagories: 'Alle categorieën',
		exports: 'Download exports',
		buyersSince: 'Download lijst kopers',
		download: 'Download',
		persons: 'Download inbrengers/cliënten',
		all: 'Alle',
		paidSellers: 'Alleen uitbetaald',
		unpaidSellers: 'Alleen niet uitbetaald',
		paidBuyers: 'Alleen betaald',
		unpaidBuyers: 'Alleen niet betaald'
	},
	category: {
		createSuccess: 'Categorie is succesvol aangemaakt',
		updateSuccess: 'Categorie is succesvol opgeslagen',
		deleteSuccess: 'Categorie is succesvol verwijderd',
		list: 'Categorieën beheer',
		add: 'Categorie toevoegen',
		edit: 'Categorie aanpassen',
		listEmptyText: 'Er zijn geen categorieën om weer te geven',
		listEmptyFilteredText: 'Er zijn geen categorieën die aan jouw zoekopdracht voldoen',
		startAuctionOrderNumber: 'Start lotnummer',
		hiddenCategory: 'Maak categorie onzichtbaar',
		startTime: 'Starttijd categorie',
	},
	tag: {
		createSuccess: 'Tag is succesvol aangemaakt',
		updateSuccess: 'Tag is succesvol opgeslagen',
		deleteSuccess: 'Tag is succesvol verwijderd',
		list: 'Tags beheer',
		add: 'Tag toevoegen',
		edit: 'Tag aanpassen',
		listEmptyText: 'Er zijn geen tags om weer te geven',
		listEmptyFilteredText: 'Er zijn geen tags die aan jouw zoekopdracht voldoen',
		hiddenTag: 'Maak tag onzichtbaar',
	},
	item: {
		pricePaid: 'Opbrengst',
		addPageTitle: 'Kavel toevoegen',
		editPageTitle: 'Kavel {itemNumber} aanpassen',
		viewPageTitle: 'Kavel {itemNumber}',
		createSuccess: 'Kavel is succesvol aangemaakt',
		updateSuccess: 'Kavel is succesvol opgeslagen',
		deleteSuccess: 'Kavel is succesvol verwijderd',
		orderingCounts: 'Lotnummers',
		items: 'Kavels',
		tags: 'Tags',
		searchPlaceholder: 'Zoek op lotnummer, inbrengcode, categorie, titel, beschrijving of biednummer',
		targetprice: 'Richtprijs {number}',
		targetpriceList: 'Richtprijs',
		limit: 'Limiet',
		title: 'Titel',
		seller: 'Inbrenger',
		category: 'Categorie',
		categoryShort: 'Afkorting',
		commission: 'Commissie',
		commisionPercentage: 'Commissie percentage',
		buyerCommission: 'Vaste cliënt commissie',
		buyerCommisionPercentage: 'Cliënt commissie %',
		sellerCommission: 'Vaste inbrenger commissie',
		sellerCommisionPercentage: 'Inbrenger commissie %',
		sellerCommissionPercentageIgnored: 'Dit bedrag wordt genegeerd omdat er een vaste inbrenger commissie ingevuld is.',
		noBid: 'Geen bod',
		itemNumber: 'Inbrengcode',
		startNumber: 'Startnummer',
		auctionOrderNumber: 'Lotnummer',
		auctionOrderNumberList: 'Lotnr',
		auctionOrderNumberSuccess: 'Lotnummers succesvol toegewezen',
		setAuctionOrderNumbers: 'Instellen',
		setAuctionOrderNumbersTitle: 'Lotnummers instellen',
		next: 'Volgende',
		previous: 'Vorige',
		nextItem: 'Volgend kavel',
		previousItem: 'Vorig kavel',
		noPreviousItem: 'Geen vorig kavel',
		noNextItem: 'Geen volgend kavel',
		noItemFoundForAuctionOrderNumber: 'Geen kavel gevonden voor lotnummer {AuctionOrderNumber}',
		usePrice: 'Maak hamerbedrag',
		sell: 'Verkoop',
		gotoAuctionOrderNumber: 'Ga naar lotnummer',
		listEmptyText: 'Er zijn geen kavels om weer te geven',
		listEmptyFilteredText: 'Er zijn geen kavels die aan jouw zoekopdracht voldoen',
		paid: 'Kavel is betaald',
		paidSuccess: 'Kavel betaald',
		unPaidSuccess: 'Kavel niet betaald',
		watch: 'Kavel bekijken',
		markPaid: 'Markeer als betaald',
		markUnpaid: 'Markeer als niet betaald',
		markAll: 'Markeer alle kavels als',
		markAllPaid: 'betaald',
		markAllUnpaid: 'niet betaald',
		allItemsPaidSuccess: 'Alle kavels betaald',
		allItemsUnpaidSuccess: 'Alle kavels niet betaald',
		auctionMove: 'Kavel verplaatsen',
		cantMove: 'U kunt dit kavel niet verplaatsen, het kavel is al verkocht of heeft biedingen. Verwijder eerst de biedingen.',
		movedTo: 'Dit kavel is verplaatst naar',
		movedFrom: 'Dit kavel komt origineel uit',
		moveSuccess: 'Kavel succesvol verplaatst.',
		auctionMoveDialog: 'Weet u zeker dat u dit kavel naar de veiling "{auctionName}" wilt verplaatsen?',
		selectAuction: 'Selecteer veiling',
		edit: 'Kavel aanpassen',
		quality: 'Kavel kwaliteit',
		selectQuality: 'Selecteer kwaliteit',
		parts: 'Aantal delen',
		description: 'Beschrijving',
		changeSeller: 'Inbrenger wijzigen',
		changeSellerModal: 'Weet u zeker dat u de inbrenger wilt wijzigen naar "{sellerName}"?',
		noPhotoCost: 'Geen fotokosten rekenen',
		exportExcel: 'Exporteer kavels naar Excel',
		list: 'Kavellijst'
	},
	media: {
		deleteModalMessage: 'dit media item',
		deleteError: 'Er is iets fout gegaan tijdens het verwijderen',
		deleteSuccess: 'Media item is succesvol verwijderd'
	},
	person: {
		createSuccess: 'Persoon is succesvol aangemaakt',
		updateSuccess: 'Persoon is succesvol opgeslagen',
		deleteSuccess: 'Persoon is succesvol verwijderd',
		list: 'Personen beheer',
		add: 'Persoon toevoegen',
		edit: 'Persoon aanpassen',
		fixedBidNumber: 'Vast biednummer',
		codeFieldRequiredError: 'Code veld is verplicht.',
		listEmptyText: 'Er zijn geen personen om weer te geven',
		listEmptyFilteredText: 'Er zijn geen personen die aan jouw zoekopdracht voldoen',
		iban: 'IBAN',
		accountName: 'Tenaamstelling rekening',
		bic: 'BIC',
		cash: 'Per kas',
		bankAddress: "Bank adres",
		registeredAt: 'Geregistreerd op',
		userIsAdmin: 'Deze gebruiker is administrator',
		invoiceEmails: 'Factuur emailadressen',
		note: 'Notitie',
		zipcode: 'Postcode',
		city: 'Plaatsnaam',
		address: 'Straatnaam en huisnummer',
		company: 'Bedrijfsnaam',
		telephone: 'Telefoon',
		mobile: 'Mobiel',
		email: 'Email',
		firstName: 'Voornaam',
		lastNamePrefix: 'Tussenvoegsel',
		lastName: 'Achternaam',
		salutation: 'Aanhef',
		country: 'Land',
		import: 'Personen Importeren',
		uploadNextlotFile: 'Upload nextlot bestand',
		importFailedPersons: 'Deze personen konden niet geimporteerd worden',
		importSuccessPersons: 'Er zijn in totaal {personCount} personen succesvol geïmporteerd, waarvan {personCountNew} nieuw',
		noEmail: 'Deze persoon aanmaken zonder e-mailadres.'
	},
	seller: {
		listEmptyText: 'Er zijn geen inbrengers om weer te geven',
		listEmptyFilteredText: 'Er zijn geen inbrengers die aan jouw zoekopdracht voldoen',
		itemsInserted: 'Kavels ingebracht',
		noSellerCode: 'Inbrenger heeft geen inbrengcode',
		listSearchPlaceholder: 'Zoek op naam of inbrengcode',
		moveItemsTooltip: 'Verplaats niet-verkochte kavels naar andere veiling',
		moveItemsTitle: 'Verplaats kavels',
		moveItemsAction: 'Verplaatsen',
		moveItemsSuccess: 'De kavels zijn successvol verplaatst',
		moveItemsError: 'Er is iets misgegaan met het verplaatsen van de kavels',
		moveItemsQuestionAuction: 'Naar welke veiling wilt u de niet-verkochte kavels verplaatsen?',
		moveItemsWarning: 'De biedingen van {unsoldItems} worden verwijderd tijdens het verplaatsen naar een andere veiling. Verplaats niet als u deze biedingen wilt behouden.',
		moveItemsUnsoldItems: 'alle niet-verkochte kavels van deze inbrenger',
	},
	buyer: {
		listEmptyText: 'Er zijn geen cliënten om weer te geven',
		listEmptyFilteredText: 'Er zijn geen cliënten die aan jouw zoekopdracht voldoen',
		bidsCount: 'Kavels gekocht',
		noPerson: 'Geen cliënt gekoppeld aan biednummer',
		noPersonInvoice: 'Factuur niet beschikbaar: biednummer heeft geen cliënt.',
		listSearchPlaceholder: 'Zoek op naam of biednummer'
	},
	sellerCost: {
		inspectionCost: 'Keurkosten',
		restorationCost: 'Restauratiekosten',
		payoutBank: 'Uitbetaald bank',
		payoutCash: 'Uitbetaald cash',
		payoutPin: 'Uitbetaald pin',
		toPayout: 'Uit te betalen',
		fixedCommission: 'Vaste commissie',
		fixedCommissionPercentage: 'Vast commissie percentage',
		commission: 'Commissie',
		updateSuccess: 'Verkoop kosten succesvol opgeslagen',
		sellerCost: 'Verkoop kosten',
		itemsCount: 'Aantal kavels',
		transportCost: 'Transportkosten',
		valuationCost: 'Taxatiekosten',
		photoCost: 'Fotokosten',
		fixedPhotoCost: 'Vaste fotokosten',
		total: 'Kosten totaal',
		income: 'Opbrengst kavels',
		sellerItems: 'Ingebracht',
		noItems: 'Geen kavels ingebracht',
		note: 'Notitie rapportage'
	},
	buyerCost: {
		fixedCommissionPercentage: 'Vast opgeld percentage',
		commission: 'Opgeld',
		updateSuccess: 'Aankoop kosten succesvol opgeslagen',
		note: 'Notitie factuur',
		buyerTotal: 'Hamerbedrag',
		tableMoney: 'Tafelgeld',
		bought: 'Aangeschaft',
		noBids: 'Geen biedingen voor dit biednummer gevonden'
	},
	emailLog: {
		seller: {
			overview:	   'Ingebrachte goederen',
			sold:	  	   'Verkochte goederen',
			'sold-paid':   'Verkochte goederen, betaald',
			'sold-unpaid': 'Verkochte goederen, niet betaald'
		},

		buyer: {
			overview: 'Alle goederen',
			paid:	  'Betaalde goederen',
			unpaid:   'Niet betaalde goederen'
		},

		general: {
			verification: 'Verificatie',
			activation:	  'Activatie',
		},

		appointment: {
			created:   'Afspraak gepland',
			cancelled: 'Afspraak geannuleerd',
		},

		status: 'Status',
		status: {
			pending: 'In de wachtrij',
			failed:  'Verzenden mislukt',
			success: 'Verzonden',
		},

		actions: 'Acties',
		actions: {
			seeContent: 'Bekijk inhoud',
			downloadAttachment: 'Download bijlage',
		},

		noMailSent: 'Er zijn nog geen emails verzonden',
		attachment: 'Bijlage',
		auction:    'Veiling',
		content:    'Inhoud',
		createdAt:	'Aangemaakt op',
		type:		'Soort',
	}
}



// WEBPACK FOOTER //
// ./src/language/locales/nl.js